import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { isHexColor } from 'wix-rich-content-common';
export const colorScheme = {
    dark1: {
        color: '#06070d',
        index: 0
    },
    light1: {
        color: '#f2f2f2',
        index: 1
    },
    green: {
        color: '#00e59b',
        index: 2
    },
    red: {
        color: '#f53948',
        index: 3
    },
    purple: {
        color: '#7579ff',
        index: 4
    },
    blue: {
        color: '#0289ff',
        index: 5
    }
};
export const viewerCustomForegroundStyleFn = (style)=>{
    let colorRule = {};
    if (colorScheme[style] && isHexColor(colorScheme[style].color)) {
        colorRule = {
            color: colorScheme[style].color
        };
    } else if (isHexColor(style)) {
        colorRule = {
            color: style
        };
    }
    return colorRule;
};
export const customForegroundStyleFn = (styles)=>styles.toArray().reduce((cssStyle, style)=>{
        return _object_spread({}, cssStyle, viewerCustomForegroundStyleFn(style));
    }, {});
export const viewerCustomBackgroundStyleFn = (style)=>{
    let colorRule = {};
    if (colorScheme[style] && isHexColor(colorScheme[style].color)) {
        colorRule = {
            backgroundColor: colorScheme[style].color
        };
    } else if (isHexColor(style)) {
        colorRule = {
            backgroundColor: style
        };
    }
    return colorRule;
};
export const customBackgroundStyleFn = (styles)=>styles.toArray().reduce((cssStyle, style)=>{
        return _object_spread({}, cssStyle, viewerCustomBackgroundStyleFn(style));
    }, {});
export const styleSelectionPredicate = (style)=>{
    return colorScheme[style] && isHexColor(colorScheme[style].color) || isHexColor(style);
};

//# sourceMappingURL=text-color-style-fn.js.map